// @flow

import React from "react";
import { connect } from "react-redux";

import { getChart } from "src/reducers";

import type { AppState, Charts } from "src/types";

type Props = {
  chart: Charts,
};

const Description = ({ chart }: Props) => <>{chart.description}</>;

const mapStateToProps = ({ app }: { app: AppState }, props) => ({
  chart: getChart(app, props.id),
});

export default connect(mapStateToProps)(Description);
